module.exports = require("@wildboar/pki-stub/src/lib/modules/PKI-Stub/AttributeTypeAndValue.ta");